module.exports = __webpack_public_path__ + "static/media/toPage.2350809a.svg";